import React from "react";
import { Dialog, DialogContent, Stack } from "@mui/material";
// import { Transition } from "../Transition/Transition";
import Fade from "@mui/material/Fade";

import { PlayArrowOutlined } from "@mui/icons-material";

import "./UserInteractionOverlay.scss";

const UserInteractionOverlay = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      className="user-interaction-overlay-dialog"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "transparent",
          backdropFilter: "blur(24px)",
          width: "1280px",
          height: "860px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "none", // Change backdrop color
        },
      }}
      maxWidth={false}
      TransitionComponent={Fade}
      keepMounted
      disablePortal
    >
      <Stack className="dotted-background">
        <DialogContent>
          <div className="pause-overlay-container">
            <div className="pause-button" onClick={onClose}>
              <PlayArrowOutlined sx={{ fontSize: "10rem" }} />
              {/* <span className="pause-label">Paused</span> */}
            </div>
            <div className="pause-text-box">
              <p>Welcome back, Investigator. Let`s start where you left off.</p>
            </div>
          </div>
        </DialogContent>
      </Stack>
    </Dialog>
  );
};

export default UserInteractionOverlay;
